import {onDomReady} from "./observer.js";

class Footer {
    constructor() {
        this.options = {
            footerColumnTitle: '[data-footer-column-title]',
            footerColumnList: '[data-footer-column-list]',
            footerColumnTitleOpened: 'footer__column-title_opened',
            footerColumnListOpened: 'footer__column-list_opened',
        };

        this.elements = {
            footerColumnTitleElements: document.querySelectorAll(this.options.footerColumnTitle),
        };

        this.init();
    }

    init() {
        if (this.elements.footerColumnTitleElements) {
            const footerColumnTitleElements = this.elements.footerColumnTitleElements;
            footerColumnTitleElements.forEach((footerColumnTitle) => {
                footerColumnTitle.addEventListener('click', (event) => {
                    const footerColumnListElement = footerColumnTitle.nextElementSibling;
                    if (footerColumnListElement && footerColumnListElement.matches(this.options.footerColumnList)) {
                        footerColumnListElement.classList.toggle(this.options.footerColumnListOpened);
                        footerColumnTitle.classList.toggle(this.options.footerColumnTitleOpened);
                    }
                });
            });
        }
    }
}

onDomReady(() => {
    const header = new Footer();
}, false);